<template>
  <div class="home-nav-bar-container" :class="{ blue_model: model == 'blue' }">
    <div class="nav-bar-logo-container">
      <img
        class="animated wobble"
        @click="linkTo('/home')"
        v-if="model == 'white'"
        src="@/assets/images/ls-logo.png"
        alt=""
      />
      <img
        class="animated wobble"
        @click="linkTo('/home')"
        v-if="model == 'blue'"
        src="@/assets/images/ls-logo-white.png"
        alt=""
      />
    </div>
    <div class="nav-btn-container">
      <ul>
        <li @click="linkTo('/')">首页</li>
        <li @click="linkTo('/product/zn')">产品中心</li>
        <li @click="linkTo('/solution')">解决方案</li>
        <li @click="toPartner">合作伙伴</li>
        <li @click="linkTo('/aboutUs')">关于栗鼠</li>
        <li class="experience-btn wave" @click="linkTo('/experience')">
          体验中心
        </li>
      </ul>
    </div>
    <el-dropdown>
      <div class="menu-btn">
        <img
          v-if="model == 'blue'"
          src="@/assets/images/icon-menu-white.png"
          alt=""
        />
        <img v-else src="@/assets/images/icon-menu.png" alt="" />
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="linkTo('/')">首页</el-dropdown-item>
        <el-dropdown-item @click.native="linkTo('/product/zn')"
          >产品中心</el-dropdown-item
        >
        <el-dropdown-item @click.native="linkTo('/solution')"
          >解决方案</el-dropdown-item
        >
        <el-dropdown-item @click.native="toPartner">合作伙伴</el-dropdown-item>
        <el-dropdown-item @click.native="linkTo('/aboutUs')"
          >关于栗鼠</el-dropdown-item
        >
        <el-dropdown-item @click.native="linkTo('/experience')"
          >体验中心</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  props: {
    model: {
      type: String,
      default: "white",
    },
  },
  data() {
    return {};
  },
  methods: {
    linkTo(path) {
      this.$router.push(path);
    },
    toPartner() {
      if (this.$route.name == "home") {
        // this.$emit("toPartner");
      } else {
        this.$router.push({
          path: "/",
          query: {
            to: "partner",
          },
        });
      }
      this.$emit("toPartner");
    },
  },
};
</script>

<style lang="scss" scoped>
.home-nav-bar-container {
  .menu-btn {
    display: none;
    img {
      height: 40px;
    }
  }
  position: fixed;
  // position: sticky;
  top: 0;
  z-index: 99;
  width: 100%;
  height: 70px;
  padding: 0 10%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  .nav-bar-logo-container {
    width: 40%;
    img {
      width: 79px;
      height: 24px;
      cursor: pointer;
      user-select: none;
    }
  }
  .nav-btn-container {
    // width: 50%;
    flex: 1;
    min-width: 500px;
    // background: #fff;
    ul {
      display: flex;
      justify-content: space-between;
      align-items: center;
      li {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #000000;
        cursor: pointer;
        user-select: none;
        &:hover {
          opacity: 0.8;
        }
        &:active {
          opacity: 0.6;
        }
      }
      .experience-btn {
        width: 104px;
        height: 34px;
        background-image: linear-gradient(270deg, #119dfd 0%, #0764fb 100%);
        border-radius: 17px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
@media screen and (max-width: 800px) {
  .home-nav-bar-container {
    .nav-btn-container {
      display: none;
    }
    .menu-btn {
      display: block;
    }
  }
}
.blue_model {
  background: #0764fb;
  border-bottom: 1px solid #5896fc;
  .nav-btn-container {
    ul {
      li {
        color: #ffffff;
        &:hover {
          opacity: 1;
          color: #eee;
        }
        &:active {
          opacity: 1;
          color: #ddd;
        }
      }
      .experience-btn {
        background: #ffffff;
        color: #0764fb !important;
        &:active {
          background: #eee;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/common/navBar.vue